import { useQuery } from '@tanstack/react-query'
import { profileService } from '@/services/profileService'
import { validateUsername } from '@/utils/username'

/**
 * Hook to check username availability
 * Includes client-side validation before making API call
 */
export function useUsernameCheck(username: string, enabled = true) {
  // Client-side validation first
  const validation = validateUsername(username)

  return useQuery({
    queryKey: ['usernameCheck', username],
    queryFn: () => profileService.checkUsernameAvailability(username),
    enabled: enabled && username.length >= 3 && validation.valid,
    staleTime: 30 * 1000, // 30 seconds
    retry: false, // Don't retry on 404 or validation errors
  })
}
